import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { lehighValleyConfig } from "./data";

export default function LehighValleyPage() {
  return <CityPageTemplate config={lehighValleyConfig} />;
}